import { globalCatch } from "../../../_services/global-catch";
import { SET_CERT_APPLICATION_STATUS, SET_ACE_CERT_APPLICATION_STATUS } from "./constants";
import { studentAcademicProgramsTitleApi, studentAcademicProgramsCatApi, studentAcademicProgramsMadApi } from "../../../_services/expedient-service";
import { toastService } from "../../../_services/toast-service";
import { t } from "../../../_i18n"

export const setCertApplicationStatus = payload => ({ type: SET_CERT_APPLICATION_STATUS, payload });
export const setCatCertApplicationStatus = payload => ({ type: SET_ACE_CERT_APPLICATION_STATUS, payload });

export const getCertApplicationStatus = (studentId, academicProgramId) => globalCatch.catch(async dispatch => {
    const certApplication = await (await studentAcademicProgramsTitleApi()).studentAcademicProgramTitleDocumentControllerShowByStudent(studentId, academicProgramId);
    dispatch(setCertApplicationStatus(certApplication));
})

export const getAceCertApplicationStatus = (studentId, academicProgramId) => globalCatch.catch(async dispatch => {
    const aceCertApplication = await (await studentAcademicProgramsTitleApi()).studentAcademicProgramTitleDocumentAceControllerShowByStudent(studentId, academicProgramId);
    dispatch(setCatCertApplicationStatus(aceCertApplication));
})

export const uploadCertPaymentReceipt = (studentId, file, academicProgramId, payedAt) => globalCatch.catch(async () => {
    const response = { error: null, data: null };

    try {
        response.data = await (await studentAcademicProgramsTitleApi()).studentAcademicProgramTitleDocumentControllerStore(studentId, file, academicProgramId, payedAt);
        toastService.showToast({ message: t("Solicitud enviada correctamente"), type: 'info' });
    } catch (e) {
        response.error = handleApiError(e) || t("Ha ocurrido un error");
    } 

    return response;
})

export const uploadAceCertPaymentReceipt = (studentId, opts) => globalCatch.catch(async () => {
    const response = { error: null, data: null };

    try {
        response.data = await (await studentAcademicProgramsTitleApi()).studentAcademicProgramTitleDocumentAceControllerStore(studentId, opts);
        toastService.showToast({ message: t("Solicitud enviada correctamente"), type: 'info' });
    } catch (e) {
        if (e?.body?.message) {
            response.error = e.body.message;
            toastService.showToast({ message: e.body.message, type: 'danger' });
        } else if (e?.body?.errors) {
            const errorObject = e.body.errors;
            const errorKeys = Object.keys(errorObject);
            const message = errorObject[errorKeys[0]][0];
            toastService.showToast({ message: message, type: 'danger' });
        } else {
            toastService.showToast({ message: t("Ha ocurrido un error"), type: 'danger' });
        }
    }

    return response;
})

export const generateVoucher = (type, studentId, opts) => globalCatch.catch(async () => {
    const response = { error: null, data: null };

    try {
        if (type === "CAT") {
            response.data = await (await studentAcademicProgramsCatApi()).studentAcademicProgramCatControllerGenerateVoucher(studentId, opts);
        } else if (type === "MAD") {
            response.data = await (await studentAcademicProgramsMadApi()).studentAcademicProgramMadControllerGenerateVoucher(studentId, opts);
        } else {
            throw new Error("Invalid type");
        }
        toastService.showToast({ message: t("Solicitud enviada correctamente"), type: 'info' });
    } catch (e) {
        if (e?.body?.message) {
            response.error = e.body.message;
            toastService.showToast({ message: e.body.message, type: 'danger' });
        } else if (e?.body?.errors) {
            const errorObject = e.body.errors;
            const errorKeys = Object.keys(errorObject);
            const message = errorObject[errorKeys[0]][0];
            toastService.showToast({ message: message, type: 'danger' });
        } else {
            toastService.showToast({ message: t("Ha ocurrido un error"), type: 'danger' });
        }
    }

    return response;
})

const handleApiError = e => {
    if (e?.body?.message) {
        toastService.showToast({ message: e.body.message, type: 'danger' });
        return e.body.message;
    } else if (e?.body?.errors) {
        const errorObject = e.body.errors;
        const errorKeys = Object.keys(errorObject);
        const message = errorObject[errorKeys[0]][0];
        toastService.showToast({ message: message, type: 'danger' });
    } else {
        toastService.showToast({ message: t("Ha ocurrido un error"), type: 'danger' });
    }
}